import clsx from 'clsx'
import { Sparkles } from 'lucide-react'

const Subtitle = ({
  customIcon,
  icon,
  subtitle,
  center,
  textColor = 'text-vblue2',
  gradientTextColor = 'from-vblue2 via-vblue3 to-vcyan1',
  custom,
}) => {
  return (
    <strong
      className={clsx(
        'mona mb-2.5 block w-full items-center gap-1.5 text-[0.8125rem] font-bold uppercase tracking-widest',
        textColor,
        center === true && 'mx-auto justify-center text-center',
        custom,
      )}
    >
      {icon !== false && !customIcon ? (
        <Sparkles className="relative bottom-px mr-2 inline-block size-[0.9375rem]" />
      ) : null}

      {customIcon ? customIcon : null}
      <span
        className={clsx(
          'bg-gradient-to-br bg-clip-text text-transparent',
          gradientTextColor,
        )}
      >
        {subtitle}
      </span>
    </strong>
  )
}

export default Subtitle
